//Library items
import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import {withRouter} from 'react-router-dom';
import {parseSearchParams} from '../../Utilities/Utils.js';
import {  Switch, Route  } from 'react-router-dom';
import ReactGA from 'react-ga';


//visual components
import DGRJoin from '../Join/Join.js';
import DGRTest from '../Test/Test.js';
import DGRTest2 from '../Test2/Test2.js';
import DGRTest3 from '../Test3/Test3.js';
import DGRMembershipOptions from '../MembershipOptions/MembershipOptions.js';
//possibly remove this file
import DGRHome from '../Home/Home.js'
import DGRHeader from '../Header/Header.js'
import DGRCreatePass from '../CreatePass/CreatePass.js';
import DGREnterPass from '../EnterPass/EnterPass.js';
import DGRWaiver from '../Waiver/Waiver.js';
import DGRGuardian from '../Guardian/Guardian.js';

import DGRAuthLogin from '../AuthLogin/AuthLogin.js';
import DGRAuthForgot from '../AuthForgot/AuthForgot.js';
import DGRAuthValidate from '../AuthValidate/AuthValidate.js';
import DGRAuthVerify from '../AuthVerify/AuthVerify.js';
import DGRAuthCreate from '../AuthCreate/AuthCreate.js';
import DGRMemberMenu from '../MemberMenu/MemberMenu.js';
import DGRMemberPurchase from '../MemberPurchase/MemberPurchase.js';
import DGRMemberUnavailable from '../MemberUnavailable/MemberUnavailable.js';

import DGRExpired from '../Expired/Expired.js';
import DGRLead from '../Lead/Lead.js';
import DGREnjoyVisit from '../EnjoyVisit/EnjoyVisit.js';
import DGREnjoyTour from '../EnjoyTour/EnjoyTour.js';
import DGRFirstVisit from '../FirstVisit/FirstVisit.js';
import DGRReturnVisit from '../ReturnVisit/ReturnVisit.js';
import DGRUnder18 from '../Under18/Under18.js';
import DGRDebug from '../Debug/Debug.js';
import DGRFontDisplay from '../FontDisplay/FontDisplay.js';
import DGRLoadingModal from '../LoadingModal/LoadingModal.js';
import DGRBackground from '../Background/Background.js';

//utilities
import IdleTimer from '../../Utilities/IdleTimer'
import BackgroundDataStoreUpdater from '../BackgroundDataStoreUpdater/BackgroundDataStoreUpdater'
import cookie from 'js-cookie'



import '../DGR.css';



class DGRApp extends Component {

    componentDidMount(){
        var searchParams = parseSearchParams(this.props.location.search)
        //searchParams.club_number = '00202'

        // If the club_number only has 3 digits, like 202, add 00 to make it 00202.
        if ( searchParams.club_number && searchParams.club_number.length === 3 ) {
            searchParams.club_number = '00' + searchParams.club_number;
        }

        // If the club_number only has 2 digits, like 86, add 000 to make it 00086.
        if ( searchParams.club_number && searchParams.club_number.length === 2 ) {
            searchParams.club_number = '000' + searchParams.club_number;
        }

        if ( searchParams.restore && cookie.get('enteredInfo') ) {
            var storedData = {};
            // Get cookie info, check against lead_number
            try { storedData = JSON.parse( cookie.get('enteredInfo') ); } catch (o_0) {}
            // Only use this data if we were able to get good info.
            if ( storedData.lead_number ) {
                this.props.DGRStore.values = storedData;
                ReactGA.set({ userId: this.props.DGRStore.values.lead_number });
                ReactGA.set({ dimension3: ''+this.props.DGRStore.values.id });
                ReactGA.set({ dimension4: ''+this.props.DGRStore.values.lead_number });
                ReactGA.set({ dimension5: this.props.DGRStore.values.pass_code });
                ReactGA.set({ dimension6: this.props.DGRStore.values.source });
                ReactGA.set({ dimension7: new Date().getTime() });
            } else if ( storedData.member_number ) {
                this.props.DGRStore.values = storedData;
            }
        }

        this.props.DGRStore.getVersion()

        // No matter if we restored the saved user info,
        // wipe out any cookies that might be there.
        cookie.remove( 'enteredInfo', {
            path: '/',
            domain: window.location.hostname,
            secure: true
        } );

        if ( searchParams.club_number ){
            this.props.DGRStore.getClubData(searchParams.club_number)
        }else if ( cookie.get('club_number')) {
            this.props.DGRStore.getClubData(cookie.get('club_number'))
        }else{
            //TODO - logic is repeated in isDataReady - ripe for refactor
			this.props.DGRModalStore.setSection('club_number')
			this.props.DGRModalStore.setCloseHidden()
			this.props.DGRModalStore.openModal()
		}

        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
        this.earlyIdle = this._earlyIdle.bind(this)
        this.onActive = this._onActive.bind(this)
    }

    isDataReady(){
        //if no club number, get club number
        //if no product data, get product data
       if (this.props.DGRStore.clubDataLoaded){
           //we have club data, get Product data
            if (!this.props.DGRProductStore.productDataLoaded){
                if (!this.props.DGRProductStore.inProgress){
                    this.props.DGRProductStore.getClubProducts(this.props.DGRStore.club_number)
                }
            }
           this.props.DGRModalStore.closeModal()
        }else{
            if (this.props.DGRStore.inProgress === false){
                this.props.DGRModalStore.setSection('club_number')
				this.props.DGRModalStore.setCloseHidden()
                this.props.DGRModalStore.openModal()
            }
        }
    }

    componentWillUpdate(){
        this.isDataReady()
    }

    _onActive(e) {
        if (this.props.DGRModalStore.section === 'timeout'){ 
            this.props.DGRModalStore.closeModal()
        }
    }

    _onIdle(e) {
        //Do not reset if api calls are still firing
        if (!this.props.DGRStore.inProgress && !this.props.DGRProductStore.inProgress ){
            this.props.DGRStore.clearValues();
            if ( window.location.pathname !== '/go/dgr/' && window.location.pathname !== '/go/dgr' ) {
                ReactGA.set({ dimension7: new Date().getTime() });
                ReactGA.event({
                    category: 'Navigation',
                    action: 'Timeout'
                });
                this.props.history.replace('');
            }

            //version checker
            var currentVersion = this.props.DGRStore.version;
            this.props.DGRStore.getVersion().then( () => {
                var newVersion = this.props.DGRStore.version;
                if ( currentVersion.version && ( newVersion.version !== currentVersion.version ) ){ 
                    window.location.href = window.location.protocol + '//' + window.location.hostname + '/go/dgr?club_number=' + this.props.DGRStore.club_number + '&ran=' + new Date().getTime();
                }
            });

        }
    }

    _earlyIdle(e) {
        if ( window.location.pathname !== '/go/dgr/' && window.location.pathname !== '/go/dgr' ) {
            this.props.DGRModalStore.setSection('timeout')
            this.props.DGRModalStore.setCloseHidden()
            this.props.DGRModalStore.openModal()
        }
    }


    render(){
                if (this.props.DGRStore.clubDataLoaded && this.props.DGRProductStore.productDataLoaded){
                return (
                <div className="dgr">
                    <DGRBackground/>
                     
                    <DGRHeader history={this.props.history}/>
                    
                    <div className='dgrSection'>
                        <Switch basename="/go/dgr">
                            <Route path="/test" component={DGRTest} />
                            <Route path="/test2" component={DGRTest2} />
                            <Route path="/test3" component={DGRTest3} />
                            <Route path="/font" component={DGRFontDisplay} />

                            <Route path="/enter_pass" component={DGREnterPass} />
                            <Route path="/create_pass" component={DGRCreatePass} />
                            <Route path="/join" component={DGRJoin} />
                            <Route path="/membership_options" component={DGRMembershipOptions} />

                            <Route path="/auth/login" component={DGRAuthLogin} />
                            <Route path="/auth/forgot" component={DGRAuthForgot} />
                            <Route path="/auth/validate" component={DGRAuthValidate} />
                            <Route path="/auth/verify" component={DGRAuthVerify} />
                            <Route path="/auth/create" component={DGRAuthCreate} />

                            <Route path="/member/menu" component={DGRMemberMenu} />
                            <Route path="/member/purchase" component={DGRMemberPurchase} />
                            <Route path="/member/unavailable" component={DGRMemberUnavailable} />

                            <Route path="/expired" component={DGRExpired} />

                            {/* ----THESE ROUTES REQUIRE VARIOUS DATA TO BE POPULATED */}
                            {/* ----DATA CHECKS OCCUR IN COMPONENT DID MOUNT IN COMPONENT */}

                            <Route path="/lead" component={DGRLead} />
                            <Route path="/sign_waiver" component={DGRWaiver} />
                            <Route path="/first_visit" component={DGRFirstVisit} />
                            <Route path="/enjoy_visit" component={DGREnjoyVisit} />
                            <Route path="/enjoy_tour" component={DGREnjoyTour} />
                            <Route path="/return_visit" component={DGRReturnVisit} />
                            <Route path="/guardian" component={DGRGuardian} />
                            <Route path="/under_18" component={DGRUnder18} />

                            {/* ------------- */}

                            <Route path="/" component={DGRHome} />
                        </Switch>
                    </div>
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdle}
                        earlyIdle={this.earlyIdle}
                        timeout={ 210000 } // 1000 * 60 * 3.5
                        reducedTimeout={ 1000 * 60 * 3 }
                        endStateTimeout={ 1000 * 40 }
                        endStateReducedTimeout={ 1000 * 20 }
                    >
                    </IdleTimer>
                    <BackgroundDataStoreUpdater/>
                    <DGRDebug/>
                    <DGRLoadingModal/>
                </div>
            )
           }else{
               return(
                    <div>
                    <DGRLoadingModal/>
                    <div className="rootloading">Loading...<i>There may be a network outage or service maintenance taking place. Please wait a few minutes then refresh the page.</i></div>
                    </div>
               )
           }
    }
}

DGRApp = inject('DGRProductStore','DGRStore','DGRModalStore')(observer(DGRApp))
DGRApp = withRouter(DGRApp)

export default DGRApp;



// WEBPACK FOOTER //
// ./src/components/DGR/App/App.js